<template>
  <Transition name="fade">
    <div v-if="bannerImg.length" class="banner">
      <el-carousel height="320px">
        <el-carousel-item v-for="item in bannerImg" :key="item._id">
          <RouterLink target="_blank" :to="`${item.bannerUrl}`">
            <img v-lazy="item.bannerImg" alt="" />
          </RouterLink>
        </el-carousel-item>
      </el-carousel>
    </div>
    <ReadBannerSkeleton v-else />
  </Transition>
</template>

<script>
import ReadBannerSkeleton from "./read-banner-skeleton.vue";
import { findBanner } from "@/api/home";
import { ref } from "vue";
export default {
  components: {
    ReadBannerSkeleton,
  },
  setup() {
    const bannerImg = ref([]);
    findBanner(1719395177343)
      .then((data) => {
        bannerImg.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    return { bannerImg };
  },
};
</script>

<style lang="less" scoped>
a {
  img {
    width: 1920px;
    height: 320px;
  }
}
</style>
